import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loadingFlag:0,
    timezoneDropdownList: {},
    travelDistanceList: {},
    emrehrList: {},
    errorMessage: null,
    successMessage: null,
    action: '',
    addToContact: '',
    setLocationName: '',
    saveButtonDisabled: false,
    locationMapCandidateList: [],
    zipCodeInfo: {},
    newlocationid: ''
}

export const addCompanySlice = createSlice({
    name: 'addCompany', initialState,
    reducers: {
        setInitalState: (state, action) => {
            state.successMessage = null;
            state.errorMessage = null;
            state.addToContact = false;
            state.action = '';
            state.setLocationName = '';
        },
        getTimeZoneDropdownSuccess: (state, action) => {
            state.timezoneDropdownList = action.payload;
            state.errorMessage = null;
            state.successMessage = null;
        },
        getTimeZoneDropdownError: (state, action) => {
            state.timezoneDropdownList = {};
            state.errorMessage = action.payload;
        },
        getTravelDistanceSuccess: (state, action) => {
            state.travelDistanceList = action.payload;
            state.errorMessage = null;
            state.successMessage = null;
        },
        getTravelDistanceError: (state, action) => {
            state.travelDistanceList = {};
            state.errorMessage = action.payload;
            state.successMessage = null;
        },
        getEMREHRListSuccess: (state, action) => {
            state.emrehrList = action.payload;
            state.errorMessage = null;
            state.successMessage = null;
        },
        getEMREHRListError: (state, action) => {
            state.emrehrList = {};
            state.errorMessage = action.payload;
            state.successMessage = null;
        },
        addNewLocationSuccess: (state, action) => {
            if (action.payload.message === 'Location Name already Exist.') {
                state.errorMessage = action.payload.message;
                state.successMessage = null;
            } else {
                state.successMessage = 'New Location added successfully!';
                state.errorMessage = null;  
                if (state.action === 'add') {
                    state.addToContact = true;
                } else {
                    state.addToContact = false;
                }
            }
        },
        addNewLocationError: (state, action) => {
            state.successMessage = null;
            state.errorMessage = action.payload;
        },
        editLocationSuccess: (state, action) => {
            state.successMessage = 'Location details updated successfully!';
            state.errorMessage = null;
            if (state.action === 'add') {
                state.addToContact = true;
            }
            // state.action = action.payload;
        },
        editLocationError: (state, action) => {
            state.successMessage = {};
            state.errorMessage = action.payload;
        },
        setAction: (state, action) => {
            state.action = action.payload;
        },
        setLocationsName: (state, action) => {
            state.setLocationName = action.payload;
        },
        setMapCandidate: (state, action) => {
            state.locationMapCandidateList = action.payload
        },
        getZipCodeInfoSuccess: (state, action) => {
            state.zipCodeInfo = action.payload;
            state.errorMessage = null;
        },
        getZipCodeInfoError: (state, action) => {
            state.zipCodeInfo = {};
            state.errorMessage = action.payload;
        },
        setLocationsId: (state,action) => {            
            state.newlocationid=action.payload;;
        },
        setSaveButtonDisabled: (state, action) => {
            state.saveButtonDisabled = action.payload;
        },
        setLoadingFlagIncrement:state => {
            state.loadingFlag = state.loadingFlag + 1
        },
        setLoadingFlagDecrement: state => {
            if (state.loadingFlag !== 0) {
                state.loadingFlag = state.loadingFlag - 1
            }
        }
    }
});
export const {
    setInitalState,
    getTimeZoneDropdownSuccess,
    getTimeZoneDropdownError,
    getTravelDistanceSuccess,
    getTravelDistanceError,
    getEMREHRListSuccess,
    getEMREHRListError,
    addNewLocationSuccess,
    addNewLocationError,
    editLocationSuccess,
    editLocationError,
    setAction,
    setLocationsName,
    setMapCandidate,
    getZipCodeInfoSuccess,
    getZipCodeInfoError,
    setLocationsId,
    setSaveButtonDisabled,
    setLoadingFlagIncrement,
    setLoadingFlagDecrement
} = addCompanySlice.actions;

export default addCompanySlice.reducer;